export const getFullscreenElement = () => {
  const { fullscreenElement, webkitFullscreenElement, mozFullscreenElement, msFullscreenElement } = document;

  const elements = [fullscreenElement, mozFullscreenElement, webkitFullscreenElement, msFullscreenElement];

  for (let e = 0; e < elements.length; ++e) {
    const element = elements[e];
    if (typeof element !== 'undefined' && typeof element === 'object') {
      return element;
    }
  }
};
